import React from "react";
import type {
	DraggableProvidedDragHandleProps,
	DraggableProvidedDraggableProps,
	DraggableRubric,
	DraggableStateSnapshot,
	// biome-ignore lint/style/noRestrictedImports:  component usage
} from "react-beautiful-dnd";

import { Slot } from "~/components/slot";
import { isDeepEqual } from "~/tools/is-deep-equal";
import { useMemo } from "~/tools/use-memo";

import { DraggableContextProvider } from "./context/draggable";

export interface DraggableContentProps extends DraggableProvidedDraggableProps {
	snapshot: DraggableStateSnapshot;
	rubric: DraggableRubric;
	dragHandleProps: undefined | DraggableProvidedDragHandleProps;
	children: React.ReactElement;
}

export const DraggableContent = React.forwardRef<HTMLElement, DraggableContentProps>(
	({ snapshot, rubric: { mode, ...rubric }, dragHandleProps, ...props }, ref) => {
		const context = useMemo(
			() => ({
				dragHandleProps,
				value: { ...snapshot, ...rubric },
			}),
			// biome-ignore lint/correctness/useExhaustiveDependencies(rubric): can change on every render due to custom compare
			[snapshot, rubric, dragHandleProps],
			isDeepEqual,
		);

		return (
			<DraggableContextProvider value={context}>
				<Slot ref={ref} {...props} />
			</DraggableContextProvider>
		);
	},
);
